import css from './brand-lockup.module.css';

// The site's mark, the sibling of riviera-todo.com's: the same gold sun and
// the same three parallel bands — three dunes, the bottom one in riviera's
// blue. Also the favicon (public/favicon.svg) —
// keep the paths in sync.
const RAYS = 'M24 3v3M24 26v3M11 16h3M34 16h3M15 7l2 2M31 23l2 2M33 7l-2 2M17 23l-2 2';
const DUNE_BACK = 'M6 35C14 35 18 31.5 24 31.5S34 35 42 35';
const DUNE_FRONT = 'M6 40C14 40 18 37 24 37S34 40 42 40';
const DUNE_BLUE = 'M6 45C14 45 18 42.5 24 42.5S34 45 42 45';

export function DubaiMark({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 48 48"
      fill="none"
      stroke="#c7a35c"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false">
      <circle cx={24} cy={16} r={5.5} />
      <path d={RAYS} />
      <path d={DUNE_BACK} stroke="#e8c08e" />
      <path d={DUNE_FRONT} stroke="#c98f57" />
      <path d={DUNE_BLUE} stroke="#4f82b4" />
    </svg>
  );
}

/** Mark over "DUBAI" over "— TO DO —", as riviera-todo.com's header lockup; `large` from 1024 px. The link around it carries the accessible name. */
export function BrandLockup({ large }: { large?: boolean }) {
  return (
    <span className={`${css.lockup} ${large ? css.large : ''}`}>
      <DubaiMark className={css.mark} />
      <span className={css.name}>DUBAI</span>
      <span className={css.sub}>
        <span className={css.rule} />
        TO DO
        <span className={css.rule} />
      </span>
    </span>
  );
}
